import React from "react"
import HeaderSection from "./LandingPage/Android/HeaderSection"
import TestimonialsSection from "./TestimonialsSection"
import HomeFeatureCardsSection from "./HomeFeatureCardsSection"
import BubblesBg from "./BubblesBg/BubblesBg"
import NewsletterSubscribeSection from "./NewsletterSubscribeSection"
import PlansSection from "./LandingPage/Android/PlansSection"

const LandingPage = () => {
  return (
    <div className="overflow-hidden">
      <HeaderSection />
      <HomeFeatureCardsSection />
      <PlansSection />
      <TestimonialsSection />
      <NewsletterSubscribeSection />
      <BubblesBg variant="variant1" />
    </div>
  )
}

export default LandingPage